export const RUNTIME_ASSET_REVISION = '2026-05-01-runtime-assets-v2';

export function runtimeAssetUrl(path: string): string {
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}spv=${RUNTIME_ASSET_REVISION}`;
}

export async function clearStaleRuntimeAssetCaches(): Promise<void> {
  const cleanupTasks: Promise<unknown>[] = [];

  if (typeof navigator !== 'undefined' && navigator.serviceWorker != null) {
    cleanupTasks.push(
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) =>
          Promise.all(
            registrations
              .filter(
                (registration) =>
                  registration.scope.includes('/assets/') ||
                  registration.active?.scriptURL.includes('service-worker') === true,
              )
              .map((registration) => registration.unregister()),
          ),
        ),
    );
  }

  if (typeof caches !== 'undefined') {
    cleanupTasks.push(
      caches.keys().then((keys) =>
        Promise.all(
          keys
            .filter(
              (key) =>
                key.startsWith('smashparty-assets-') || key.startsWith('smashparty-manifest-'),
            )
            .map((key) => caches.delete(key)),
        ),
      ),
    );
  }

  await Promise.all(cleanupTasks);
}
